



















































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import SystemStatsStore from '@/store/system/SystemStats.store';
import SystemInfoStore from '@/store/system/SystemInfo.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import SystemStatsDiskUsage from '@/components/System/Stats/SystemStatsDiskUsage.vue';
import SystemStatsRamUsage from '@/components/System/Stats/SystemStatsRamUsage.vue';
import SystemStatsCpuUsage from '@/components/System/Stats/SystemStatsCpuUsage.vue';
import {Notify} from '@/utils/Notify';

@Component({
  components: {SystemStatsCpuUsage, SystemStatsRamUsage, SystemStatsDiskUsage},
})
export default class SystemStatsPage extends Mixins<BaseComponent>(BaseComponent) {

  private statsStore: SystemStatsStore = getModule(SystemStatsStore, this.$store);

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private liveModeTimer: any;
  private liveMode: boolean = false;

  protected async mounted() {

    this.setLoading();
    try {
      await this.systemInfoStore.fetchHardwareInfo();
    } catch {
    }

    await this.refresh();

    this.setLoaded();

    this.liveModeTimer = setInterval(async () => {
      if (this.liveMode) {
        await this.refresh();
      }
    }, 1000);
  }

  get storageValues(): number[] | null {
    if (!this.statsStore.Stats || !this.systemInfoStore.HardwareInfo) {
      return null;
    }

    return [
      this.statsStore.Stats.Disk.Used,
      this.statsStore.Stats.Disk.Free,
      this.systemInfoStore.HardwareInfo.InternalMemorySize - (this.statsStore.Stats.Disk.Used + this.statsStore.Stats.Disk.Free),
    ];
  }

  get ramValues(): number[] | null {
    if (!this.statsStore.Stats || !this.systemInfoStore.HardwareInfo) {
      return null;
    }

    return [
      128 * 1024 * 1024 - this.statsStore.Stats.RAM.Total,
      this.statsStore.Stats.RAM.ActualUsed,
      this.statsStore.Stats.RAM.ActualFree,
    ];
  }

  get cpuLoad(): number {
    if (!this.statsStore.Stats) {
      return 0;
    }

    return (this.statsStore.Stats.System.CPULoads[0] < 1 ? this.statsStore.Stats.System.CPULoads[0] : 1) * 100;
  }

  protected beforeDestroy() {
    clearInterval(this.liveModeTimer);
  }

  private async refresh() {
    this.setLoading();
    try {
      await this.statsStore.fetchStats();
    } catch (error) {
      Notify.Error(this.logger, `Could not get system resources statistics`, error);
    } finally {
      this.setLoaded();
    }
  }
}
